import React from 'react';
import Divider from 'material-ui/Divider';
import Event from './Event';
import  {getDurationJsx} from '../service/getDuration';
import {GetTime} from "./common/GameTime";

const SessionData= ({event})=>{
    // const ev = event.events && event.events.length > 0 ? event.events[0] : event
    return(<div >
                <Divider/>
                <div className='session-top-container'>
                    <div className='sub-events-container'>
                        {event.events ? event.events.map((event,index)=><div key={'div'+index} className='inner-box'>
                            {/*<Divider key={'divider'+index}/>*/}
                            <Event event={event} key={'event'+index} index={1}/>
                        </div>):''}
                    </div>

                </div>
</div>);
};

export default SessionData;